import React from 'react'
import { Route, Switch } from 'react-router'

import { Organization } from 'screens/Organization'
import { Home } from 'screens/Home'
import { NotFound } from 'screens/NotFound'
import { PageAnalytics } from './PageAnalytics'

export function Routes() {
  return (
    <div id="app" className="font-family-system font-size-normal shade-05">
      <Switch>
        <Route exact path="/">
          <Home />
        </Route>
        <Route path="/organization">
          <Organization />
        </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
      <PageAnalytics />
    </div>
  )
}
